/******************************************************************************
   NAME:       TSVH
   AUTHOR:     Duynh
******************************************************************************/
import { Injectable } from '@angular/core';
import { ApiService, UserService } from 'app/services';
import { environment } from 'environments/environment';

@Injectable()
export class TSVHService {
  APIURL = "api/Permission";
  constructor(private api: ApiService, private user: UserService) {

  }
  getTSVH_DANHSACH(mataikhoan, danhmucid, ngay, gio, locdulieu, lockhachhang, sotrang, sodong, ip, loaipha, duan) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_TSVH" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_ngay: ngay,
        v_gio: gio,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_ip: ip,
        v_loaipha: loaipha,
        v_locdulieu: locdulieu,
        v_lockhachhang: lockhachhang,
        v_duan: duan
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getTSVHTHEONGAY_EXCEL(title, danhmucid, tungay, denngay, filename, header) {
    let cols = [];
    let language = localStorage.getItem("LANGUAGE");
    if (language == "en") {
      cols = [
        { "name": "stt", "label": "No", "horizontalalignment": "center" },
        { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
        { "name": "tentram", "label": "Substation Name", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
        { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
        { "name": "time", "label": "System Time", "horizontalalignment": "center" },
        { "name": "tu", "label": "TU", "horizontalalignment": "right" },
        { "name": "ti", "label": "TI", "horizontalalignment": "right" },

        { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
        { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
        { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
        { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
        { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
        { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
        { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" },

        { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
        { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
        { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },

        { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
        { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
        { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
        { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },


        { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
        { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
        { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
        { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },


        { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
        { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
        { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
        { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" }



      ]
    } else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "tentram", "label": "Tên trạm", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
        { "name": "time", "label": "Thời gian hệ thống", "horizontalalignment": "center" },
        { "name": "tu", "label": "TU", "horizontalalignment": "right" },
        { "name": "ti", "label": "TI", "horizontalalignment": "right" },

        { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
        { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
        { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
        { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
        { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
        { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
        { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" },

        { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
        { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
        { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },

        { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
        { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
        { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
        { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },


        { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
        { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
        { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
        { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },


        { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
        { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
        { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
        { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" }
      ]
    }



    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_TSVH_XUATEXCEL" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_denngay: denngay
      }),
      title: title,//+ " " + thoidiemtruyvan,
      header: header,
      filename: filename,
      sheets: language == "en" ? "Operating Parameters" : "Thông số vận hành",
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportFastExcel", param, filename);
  }
  getTSVH_EXCEL(data: string, mataikhoan, title, danhmucid, ngay, gio, locdulieu, lockhachhang, sotrang, sodong, ip, loaipha, filename, header) {
    let cols = [];
    let language = localStorage.getItem("LANGUAGE");
    if (loaipha == 3 && locdulieu == 0) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
          { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
          { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
          { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },
          { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
          { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
          { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
          { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
          { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
          { "name": "tu", "label": "TU", "horizontalalignment": "right" },
          { "name": "ti", "label": "TI", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
          { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
          { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
          { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },

          { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
          { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
          { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
          { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" },

          { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
          { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
          { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },
          { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" }
        ]
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
          { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
          { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
          { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },
          { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
          { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
          { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
          { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
          { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
          { "name": "tu", "label": "TU", "horizontalalignment": "right" },
          { "name": "ti", "label": "TI", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
          { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
          { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
          { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },

          { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
          { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
          { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
          { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" },

          { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
          { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
          { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },
          { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" }
        ]
      }
    }
    else if (loaipha == 1 && locdulieu == 0) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Meter type", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          // { "name": "matram", "label": "Substation Code", "horizontalalignment": "left" },
          // { "name": "macot", "label": "Poles Code", "horizontalalignment": "left" },
          { "name": "time", "label": "System time", "horizontalalignment": "center" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "ua", "label": "U (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "I (A)", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ ", "horizontalalignment": "right" },
        ]
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          // { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          // { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          // { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian hệ thông", "horizontalalignment": "center" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "ua", "label": "U (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "I (A)", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ ", "horizontalalignment": "right" },
        ]
      }
    }
    else if (locdulieu == 1) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Meter type", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "matram", "label": "Substation Code", "horizontalalignment": "left" },
          { "name": "macot", "label": "Poles Code", "horizontalalignment": "left" },
          // { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "marepeater", "label": "Repeater No", "horizontalalignment": "left" },
        ]
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          // { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },
        ]
      }
    }


    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_TSVH" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_ngay: ngay,
        v_gio: gio,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_ip: ip,
        v_loaipha: loaipha,
        v_locdulieu: locdulieu,
        v_lockhachhang: lockhachhang
      }),
      title: title,//+ " " + thoidiemtruyvan,
      header: header,
      filename: filename,
      sheets: language == "en" ? "Operating Parameters" : "Thông số vận hành",
      columns: cols,
      data: ""
    };


    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  getTSVH_KHACHHANG(mataikhoan, meterid, socongto, tungay, denngay, sotrang, sodong, ip, loaipha) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_TSVH_KH" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_socongto: socongto,
        v_sodong: sodong,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getTSVH_KHACHHANG_BieuDo(mataikhoan, meterid, socongto, tungay, denngay, ip) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_TSVH_KH_BieuDo" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_socongto: socongto,
        v_tungay: tungay,
        v_denngay: denngay,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }

  getTSVH_EXCEL_KHACHHANG(meterid: number, title: string, filename: string, tungay: string, denngay: string, loaipha: number, sotrang: number, sodong: number, socongto: string, mataikhoan: number, ip: string, header: string) {
    let cols = [];
    let language = localStorage.getItem("LANGUAGE");
    if (loaipha == 3) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          // { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          // { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
          { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
          { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
          { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },
          { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
          { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
          { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
          { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
          { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
          { "name": "tu", "label": "TU", "horizontalalignment": "right" },
          { "name": "ti", "label": "TI", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
          { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
          { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
          { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },

          { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
          { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
          { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
          { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" },

          { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
          { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
          { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },
          { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" }
        ]
      }
      else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          // { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          // { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
          { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
          { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
          { "name": "tongp", "label": "Σ P (kW)", "horizontalalignment": "right" },
          { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
          { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
          { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
          { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
          { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },
          { "name": "tu", "label": "TU", "horizontalalignment": "right" },
          { "name": "ti", "label": "TI", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ A", "horizontalalignment": "right" },
          { "name": "cosb", "label": "Cosφ B", "horizontalalignment": "right" },
          { "name": "cosc", "label": "Cosφ C", "horizontalalignment": "right" },
          { "name": "tongcos", "label": "Σ Cos", "horizontalalignment": "right" },

          { "name": "qa", "label": "QA (kVAR)", "horizontalalignment": "right" },
          { "name": "qb", "label": "QB (kVAR)", "horizontalalignment": "right" },
          { "name": "qc", "label": "QC (kVAR)", "horizontalalignment": "right" },
          { "name": "tongq", "label": "Σ Q (kVAR)", "horizontalalignment": "right" },

          { "name": "anglea", "label": "Angle A", "horizontalalignment": "right" },
          { "name": "angleb", "label": "Angle B", "horizontalalignment": "right" },
          { "name": "anglec", "label": "Angle C", "horizontalalignment": "right" },
          { "name": "frega", "label": "F (Hz)", "horizontalalignment": "right" }
        ]
      }
    }
    else if (loaipha == 1) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Meter type", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          // { "name": "matram", "label": "Substation Code", "horizontalalignment": "left" },
          // { "name": "macot", "label": "Poles Code", "horizontalalignment": "left" },
          { "name": "time", "label": "System time", "horizontalalignment": "center" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "ua", "label": "U (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "I (A)", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ ", "horizontalalignment": "right" },
        ]
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          // { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          // { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          // { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian hệ thông", "horizontalalignment": "center" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "ua", "label": "U (V)", "horizontalalignment": "right" },
          { "name": "ia", "label": "I (A)", "horizontalalignment": "right" },
          { "name": "cosa", "label": "Cosφ ", "horizontalalignment": "right" },
        ]
      }
    }
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_TSVH_KH" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_socongto: socongto,
        v_sodong: sodong,
        v_mataikhoan: mataikhoan,
        v_ip: ip
      }),
      title: title,//+ " " + thoidiemtruyvan,
      header: header,
      filename: filename,
      sheets: language == "en" ? "Operating Parameters" : "Thông số vận hành",
      columns: cols,
      data: "",
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
  getDsCongto(meterid) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_CONGTO"}',
      "para": '{"v_meterid":"' + meterid + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/giam-sat/thong-so-van-hanh/tsvh.service.ts